import { AccommodationType, Airline, ApprovalLevel, Country, DeviationTeam, OrganisationEntity, Site, TransportType, TravelType } from 'model/business-keywords';
import { IMapZoneInfoDTO } from './swagger/ApiClient';

export abstract class GeneralKeywordsApi {
  abstract getTransportTypes(): Promise<TransportType[]>;
  abstract getAccommodationTypes(): Promise<AccommodationType[]>;
  abstract getCountries(): Promise<Country[]>;
  abstract getAirlines(): Promise<Airline[]>;
  abstract getApprovalLevels(): Promise<ApprovalLevel[]>;
  abstract getOrganisationEntities(): Promise<OrganisationEntity[]>;
  abstract getTravelTypes(): Promise<TravelType[]>;
  abstract getDeviationTeams(): Promise<DeviationTeam[]>;
  abstract getMapZones(): Promise<IMapZoneInfoDTO[]>;
  abstract getSites(countries: Country[]): Promise<Site[]>;
}
